import { render, staticRenderFns } from "./cityStat2.vue?vue&type=template&id=ddebc81a&scoped=true&"
import script from "./cityStat2.vue?vue&type=script&lang=js&"
export * from "./cityStat2.vue?vue&type=script&lang=js&"
import style0 from "./cityStat2.vue?vue&type=style&index=0&id=ddebc81a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddebc81a",
  null
  
)

export default component.exports